import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostMultipart,
  ApiPostRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Work Order',
    title_repair: 'Repair Container',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Work Order',
        href: '/opc/eor/work-order',
        active: true,
      },
    ],
    items: [],
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_wo_detail',
    sortDesc: true,
    fields: [
      {
        key: 'code_wo',
        label: 'WO No',
        sortable: true,
      },
      {
        key: 'wo_date',
        label: 'WO Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: false,
      },
      {
        key: 'begin_repair',
        label: 'Start',
        sortable: false,
      },
      {
        key: 'complete_repair',
        label: 'End',
        sortable: false,
      },
      {
        key: 'vendor_name',
        label: 'Vendor',
        sortable: false,
      },
      {
        key: 'app_status',
        label: 'Cont Status',
        sortable: false,
      },
      {
        key: 'aksi',
      },
    ],
    fields_complete_repair: [
      {
        key: 'code_wo',
        label: 'WO No',
        sortable: true,
      },
      {
        key: 'wo_date',
        label: 'WO Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: false,
      },
      {
        key: 'begin_repair',
        label: 'Start',
        sortable: false,
      },
      {
        key: 'complete_repair',
        label: 'End',
        sortable: false,
      },
      {
        key: 'vendor_name',
        label: 'Vendor',
        sortable: false,
      },
      {
        key: 'repair_status',
        label: 'Status',
        sortable: false,
      },
      {
        key: 'aksi',
      },
    ],
    form: {
      id_principle: '',
      code_principle: '',
      principle: '',
      id_vendor_repair: '',
      code_vendor: '',
      vendor_name: '',
      containers: [],
    },
    repair_type: '',
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeWO(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetFormWO() {
    state.data = Object.assign({}, state.data, {
      form: {
        id_principle: '',
        code_principle: '',
        principle: '',
        id_vendor_repair: '',
        code_vendor: '',
        vendor_name: '',
        containers: [],
        remark_wo: '',
      },
      search: '',
    });
  },
};

export const actions = {
  async uploadImage({ commit }, payload) {
    commit('changeWO', {
      loading: true,
    });
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeWO', {
      loading: false,
    });

    if (!result.error) {
      return result.data.object || false;
    }
  },

  async uploadPhotoWorkOrder({ commit, state, dispatch }, payload = null) {
    commit('changeWO', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `opr/work-order/upload-photo/${payload.id}`,
      {
        photos: data.form && data.form.photos ? data.form.photos : [],
      }
    );
    commit('changeWO', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return !result.error ? true : false;
  },

  async getListWorkOrder({ commit, state }) {
    commit('changeWO', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      repair_type: data.repair_type ? data.repair_type : '',
      status_wo: data.status_wo ? data.status_wo : '',
      id_principle: data.id_principle ? data.id_principle : '',
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = data.date_filter[0]
        ? moment(data.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.date_filter[1]
        ? moment(data.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(`opr/work-order`, params);
    commit('changeWO', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListContEOR({ commit, state }) {
    commit('changeWO', {
      loading: true,
    });

    const { data } = state;
    let params = {
      principle: data.form.id_principle || '',
      q: data.search,
    };

    let result = await ApiGetRequest(`opr/work-order/search`, params);
    commit('changeWO', {
      loading: false,
    });

    if (!result.error) {
      commit('changeWO', {
        form: {
          ...data.form,
          containers: result.data.object || [],
        },
      });
    }

    return !result.error ? true : false;
  },

  async getDetailWO({ commit }, payload = null) {
    commit('changeWO', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/work-order/${payload.id}`);
    commit('changeWO', {
      loading: false,
    });

    if (!result.error) {
      commit('changeWO', {
        form: {
          ...result.data.object,
        },
      });
    }

    return !result.error ? true : false;
  },

  async createWO({ commit, state, dispatch }) {
    commit('changeWO', {
      loading: true,
    });

    const { data } = state;
    let containers = data.form.containers.filter(
      (item) => item.choose === true || item.choose === 1
    );

    if (!containers || (containers && containers.length === 0)) {
      commit('changeWO', {
        loading: false,
      });
      showNotif(dispatch, {
        message: 'Anda belum memilih container',
        type: 'error',
      });

      return false;
    }

    data.form.containers = containers;
    let result = await ApiPostRequest(`opr/work-order`, data.form);
    commit('changeWO', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateWO({ commit, state, dispatch }, payload = null) {
    commit('changeWO', {
      loading: true,
    });

    const { data } = state;
    let containers = data.form.containers.filter(
      (item) => item.choose === true || item.choose === 1
    );

    if (!containers || (containers && containers.length === 0)) {
      commit('changeWO', {
        loading: false,
      });
      showNotif(dispatch, {
        message: 'Anda belum memilih container',
        type: 'error',
      });

      return false;
    }

    data.form.containers = containers;
    let result = await ApiPutRequest(`opr/work-order/${payload.id}`, data.form);
    commit('changeWO', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteWO({ commit, dispatch }, payload = null) {
    commit('changeWO', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/work-order/${payload.id}`);
    commit('changeWO', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async beginRepairWO({ commit }, payload = null) {
    commit('changeWO', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/work-order/begin-repair/${payload.id}`
    );

    commit('changeWO', {
      loading: false,
    });

    return !result.error ? true : false;
  },

  async completeRepairWO({ commit }, payload = null) {
    commit('changeWO', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/work-order/complete-repair/${payload.id}`
    );

    commit('changeWO', {
      loading: false,
    });

    return !result.error ? true : false;
  },

  async recompleteRepairWO({ commit }, payload = null) {
    commit('changeWO', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/work-order/recomplete-repair/${payload.id}`,
      payload.form
    );

    commit('changeWO', {
      loading: false,
    });

    return !result.error ? true : false;
  },
};
